import { createUseStyles } from 'react-jss';

import { variantMapping } from '../../../components/Typography/constants';
import styling from '../../../services/styling';

export default createUseStyles(
  {
    title: {
      textAlign: 'center',
      margin: [140, 'auto', 40],
      maxWidth: styling.sizes.landingSectionMaxWidth,
    },
    subtitle: {
      margin: [0, 'auto', 45],
      maxWidth: styling.sizes.landingSectionMaxWidth,
      '& a': {
        ...variantMapping.link.styles,
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
        textDecoration: 'underline',
      },
    },
    body: {
      margin: [0, 'auto', 100],
      maxWidth: styling.sizes.landingSectionMaxWidth,
      '& p + p': {
        marginTop: 10,
      },
      '& a': {
        ...variantMapping.link.styles,
        fontWeight: 'inherit',
        textDecoration: 'underline',
      },
    },
  },
  { name: 'landingWhy' },
);
